import clsx from 'clsx';
import { Icon } from 'ui';
import React, { useState } from 'react';

import type { PracticeCourse } from '../../../types/practiceCourses';

type SubjectCardProps = {
  course: PracticeCourse;
  iconUrl?: string;
  isSelected: boolean;
  onSelect: (courseId: string) => void;
};

function SubjectCard({ course, iconUrl, isSelected, onSelect }: SubjectCardProps): JSX.Element {
  const [hasImageError, setHasImageError] = useState(false);
  const shouldShowImage = Boolean(iconUrl) && !hasImageError;

  function handleClick() {
    onSelect(course.id);
  }

  function handleImageError() {
    setHasImageError(true);
  }

  return (
    <li className="subject-selection-dialog__item">
      <button
        aria-pressed={isSelected}
        className={clsx('subject-selection-dialog__card', { 'subject-selection-dialog__card--selected': isSelected })}
        onClick={handleClick}
        type="button"
      >
        <span className={clsx('subject-selection-dialog__card-icon', { 'subject-selection-dialog__card-icon--image': shouldShowImage })}>
          {shouldShowImage ? (
            <img alt="" className="subject-selection-dialog__card-image" onError={handleImageError} src={iconUrl} />
          ) : (
            <Icon color="inherit" name="program" size="xl" />
          )}
        </span>
        <span className="subject-selection-dialog__card-title">{course.title}</span>
      </button>
    </li>
  );
}

export default SubjectCard;
